export class BookingResponse {
    bookingId: string;
    journeyId: number;
    from: number;
    to: number;
}
